(function(){
'use strict';
function initPDP(el){
  var sid=el.dataset.sid;
  var galleryMode=el.dataset.gallery||'thumbs';
  var variants=[];
  try{
    var raw=el.dataset.variants
      .replace(/&quot;/g,'"')
      .replace(/&#39;/g,"'")
      .replace(/&amp;/g,'&')
      .replace(/&lt;/g,'<')
      .replace(/&gt;/g,'>');
    variants=JSON.parse(raw);
  }catch(e){}

  // Gallery
  var slides=Array.from(el.querySelectorAll('.lp-slide'));
  var thumbItems=Array.from(el.querySelectorAll('.lp-thumb-item'));

  // Native Shopify variant -> media linkage: each slide/thumb carries the
  // media's own id (data-media-id), which matches variant.featured_media.id
  // (see Shopify/dawn snippets/product-media-gallery.liquid, which compares
  // media.id == product.selected_or_first_available_variant.featured_media.id).
  // This map lets a variant change jump the gallery to that variant's image,
  // restoring the native "click swatch -> gallery updates" behaviour.
  var mediaIdToIndex={};
  slides.forEach(function(s,i){
    var mid=s.dataset.mediaId;
    if(mid)mediaIdToIndex[mid]=i;
  });

  function goTo(idx){
    slides.forEach(function(s,i){s.classList.toggle('is-on',i===idx);});
    thumbItems.forEach(function(t,i){t.classList.toggle('is-on',i===idx);});
    var active=slides[idx];
    if(active){
      var vid=active.querySelector('video');
      if(vid&&vid.paused)vid.play();
    }
  }

  // Thumb click handlers - Option 1 only
  if(galleryMode!=='stack'){
    thumbItems.forEach(function(t){
      t.addEventListener('click',function(){goTo(+t.dataset.index);});
    });
  }

  // Lightbox (works in both modes)
  var lb=el.querySelector('#lp-lb-'+sid);
  var lbItems=[];
  if(lb){
    var lbImg=lb.querySelector('.lp-lb__img');
    var lbClose=lb.querySelector('.lp-lb__close');
    var lbPrev=lb.querySelector('.lp-lb__prev');
    var lbNext=lb.querySelector('.lp-lb__next');
    var lbIdx=0;
    el.querySelectorAll('.lp-lb-trigger').forEach(function(t){
      lbItems.push({src:t.dataset.full||t.src,alt:t.alt||''});
    });
    function lbShow(i){
      if(!lbItems.length)return;
      lbIdx=(i+lbItems.length)%lbItems.length;
      lbImg.src=lbItems[lbIdx].src;
      lbImg.alt=lbItems[lbIdx].alt;
      lb.removeAttribute('hidden');
      lb.focus();
    }
    function lbHide(){lb.setAttribute('hidden','');}
    el.querySelectorAll('.lp-lb-trigger').forEach(function(t,i){
      t.addEventListener('click',function(){lbShow(i);});
    });
    lbClose.addEventListener('click',lbHide);
    lb.addEventListener('click',function(e){if(e.target===lb)lbHide();});
    lbPrev.addEventListener('click',function(){lbShow(lbIdx-1);});
    lbNext.addEventListener('click',function(){lbShow(lbIdx+1);});
    document.addEventListener('keydown',function(e){
      if(lb.hasAttribute('hidden'))return;
      if(e.key==='Escape')lbHide();
      if(e.key==='ArrowLeft')lbShow(lbIdx-1);
      if(e.key==='ArrowRight')lbShow(lbIdx+1);
    });
    // Zoom hint - Option 1 only
    if(galleryMode!=='stack'){
      var zoomHint=el.querySelector('.lp-zoom-hint');
      if(zoomHint){
        zoomHint.addEventListener('click',function(){
          var cur=slides.findIndex(function(s){return s.classList.contains('is-on');});
          lbShow(cur>=0?cur:0);
        });
      }
    }
  }

  // Variants
  var opts={};
  function findVariant(o){
    return variants.find(function(v){
      return Object.entries(o).every(function(kv){
        return v['option'+kv[0]]===kv[1];
      });
    });
  }
  function fmt(cents){
    return (cents/100).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2});
  }
  function updateUI(v){
    if(!v)return;
    var priceEl=el.querySelector('#lp-price-'+sid);
    if(priceEl){
      if(v.compare_at_price&&v.compare_at_price>v.price){
        var disc=Math.round((v.compare_at_price-v.price)*100/v.compare_at_price);
        priceEl.innerHTML='<span class="lp-price--sale">'+fmt(v.price)+'</span>'
          +'<s class="lp-price--was">'+fmt(v.compare_at_price)+'</s>'
          +'<span class="lp-price--badge">-'+disc+'%</span>';
      }else{
        priceEl.innerHTML='<span>'+fmt(v.price)+'</span>';
      }
    }
    var vidEl=el.querySelector('#lp-vid-'+sid);
    if(vidEl)vidEl.value=v.id;
    var atc=el.querySelector('#lp-atc-'+sid);
    var atcLbl=el.querySelector('#lp-atc-lbl-'+sid);
    if(atc){
      if(v.available){
        atc.disabled=false;atc.classList.remove('is-oos');
        if(atcLbl)atcLbl.textContent='Add to Cart';
      }else{
        atc.disabled=true;atc.classList.add('is-oos');
        if(atcLbl)atcLbl.textContent='Sold Out';
      }
    }
    var stk=el.querySelector('#lp-stock-'+sid);
    if(stk){
      if(v.inventory_management&&v.inventory_quantity>0&&v.inventory_quantity<=3)
        stk.textContent='Only '+v.inventory_quantity+' left';
      else stk.textContent='';
    }
    var sbPrice=el.querySelector('#lp-sb-price-'+sid);
    if(sbPrice)sbPrice.textContent=fmt(v.price);
    var sbBtn=el.querySelector('#lp-sb-btn-'+sid);
    if(sbBtn){
      sbBtn.disabled=!v.available;
      sbBtn.textContent=v.available?'Add to Cart':'Sold Out';
    }
    // Gallery <-> variant linkage (native Shopify featured_media match).
    // Only jump the gallery if this variant actually has a featured media
    // assigned in Admin; otherwise leave the gallery as the shopper left it.
    var featuredMedia=v.featured_media||v.featured_image;
    if(featuredMedia&&featuredMedia.id!=null){
      var idx=mediaIdToIndex[String(featuredMedia.id)];
      if(idx!==undefined)goTo(idx);
    }
  }
  function updateSizeAvail(){
    el.querySelectorAll('.lp-size').forEach(function(btn){
      var test=Object.assign({},opts);
      test[btn.dataset.opt]=btn.dataset.val;
      var v=findVariant(test);
      btn.classList.toggle('is-oos',!v||!v.available);
    });
  }

  // Option clicks
  el.querySelectorAll('.lp-swatch,.lp-size').forEach(function(btn){
    btn.addEventListener('click',function(){
      var pos=btn.dataset.opt;
      var val=btn.dataset.val;
      opts[pos]=val;
      el.querySelectorAll('[data-opt="'+pos+'"]').forEach(function(b){
        var on=b.dataset.val===val;
        b.classList.toggle('is-on',on);
        if(b.hasAttribute('aria-pressed'))b.setAttribute('aria-pressed',on?'true':'false');
      });
      var lbl=el.querySelector('#lp-col-lbl-'+sid);
      if(lbl&&btn.classList.contains('lp-swatch'))lbl.textContent=val;
      updateSizeAvail();
      updateUI(findVariant(opts));
    });
  });

  // Single-open accordions
  el.querySelectorAll('.lp-acc').forEach(function(acc){
    acc.addEventListener('toggle',function(){
      if(acc.open){
        el.querySelectorAll('.lp-acc').forEach(function(other){
          if(other!==acc&&other.open)other.open=false;
        });
      }
    });
  });

  // SOLEYA FIX: Add to Cart submission (both the main button and the sticky
  // bar button) is now handled natively by the real
  // <product-form-component>/<add-to-cart-component> markup rendered in
  // sections/soleya-product.liquid — the exact same proven mechanism already
  // used by Quick Add (assets/product-form.js). The sticky bar button
  // submits the same form via its `form="..."` attribute even though it
  // sits outside the <form> in the DOM. No JS wiring is needed here for the
  // add-to-cart action itself; the previous ajaxAdd() implementation (which
  // added the item server-side but never told the rest of the cart system
  // about it, requiring a full page reload to see the update) has been
  // removed.
  var atcBtn=el.querySelector('#lp-atc-'+sid);

  // Sticky bar visibility
  var sbar=el.querySelector('#lp-sbar-'+sid);
  if(atcBtn&&sbar){
    new IntersectionObserver(function(entries){
      var vis=!entries[0].isIntersecting;
      sbar.classList.toggle('is-vis',vis);
      sbar.hidden=!vis;
      sbar.setAttribute('aria-hidden',vis?'false':'true');
    },{threshold:0}).observe(atcBtn);
  }
}
document.querySelectorAll('[data-soleya-pdp]').forEach(initPDP);
})();
